export function getClearRefreshCurrentPageReducer(state, action) {
	return {
		...state,
		refreshCurrentPageStatus: null,
	};
}
